import { render, staticRenderFns } from "./tablePositions.vue?vue&type=template&id=313c64d9&"
import script from "./tablePositions.vue?vue&type=script&lang=js&"
export * from "./tablePositions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports